var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 11.9167C15.1667 12.5125 14.6792 13 14.0833 13H4.33333C3.7375 13 3.25 12.5125 3.25 11.9167C3.25 11.3208 3.7375 10.8333 4.33333 10.8333H14.0833C14.6792 10.8333 15.1667 11.3208 15.1667 11.9167ZM3.25 7.58333C3.25 8.17917 3.7375 8.66667 4.33333 8.66667H14.0833C14.6792 8.66667 15.1667 8.17917 15.1667 7.58333C15.1667 6.9875 14.6792 6.5 14.0833 6.5H4.33333C3.7375 6.5 3.25 6.9875 3.25 7.58333ZM10.8333 16.25C10.8333 15.6542 10.3458 15.1667 9.75 15.1667H4.33333C3.7375 15.1667 3.25 15.6542 3.25 16.25C3.25 16.8458 3.7375 17.3333 4.33333 17.3333H9.75C10.3458 17.3333 10.8333 16.8458 10.8333 16.25ZM19.5108 13.9425L20.28 13.1733C20.3802 13.0729 20.4993 12.9932 20.6303 12.9389C20.7614 12.8845 20.9019 12.8565 21.0437 12.8565C21.1856 12.8565 21.3261 12.8845 21.4572 12.9389C21.5882 12.9932 21.7073 13.0729 21.8075 13.1733L22.5767 13.9425C22.9992 14.365 22.9992 15.0475 22.5767 15.47L21.8075 16.2392L19.5108 13.9425ZM18.7417 14.7117L13.1517 20.3017C13.0542 20.3992 13 20.5292 13 20.6808V22.2083C13 22.5117 13.2383 22.75 13.5417 22.75H15.0692C15.21 22.75 15.3508 22.6958 15.4483 22.5875L21.0383 16.9975L18.7417 14.7117V14.7117Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsOutline);
export default __webpack_public_path__ + "static/media/detailsOutline.cf2a47873e9df4c0bed4671ab700caa7.svg";
export { ForwardRef as ReactComponent };